import { ReactNode, Suspense } from 'react';
import { ErrorBoundary } from '../../../components';
import { LoadingPage } from '../../../pages';
import { ErrorPage } from './ErrorPage';
import { StandortContextProvider } from '@/features/standortContext/StandortContext';

export function AuthorizedPage({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary FallbackComponent={ErrorPage}>
      <Suspense fallback={<LoadingPage />}>
        <StandortContextProvider>{children}</StandortContextProvider>
      </Suspense>
    </ErrorBoundary>
  );
}
